import BarTrackWrapper from "components/BarTrackWrapper";
import { arrayOf, bool, number, string } from "prop-types";
import React from "react";
import { FALLBACK_DEFAULT_CURRENCY } from "slices/currency/constants";
import { formatCompactCurrency } from "utils/currency";

import styles from "./StageRow.module.scss";
import StageTooltipContent from "./StageTooltipContent";

const StageRow = ({
  stageName,
  color,
  opportunityCount,
  value,
  currency = FALLBACK_DEFAULT_CURRENCY.symbol,
  opportunityNames = [],
  remainingCount = 0,
  maxCount,
  isPlaceholder = false,
}) => {
  const widthPct = isPlaceholder
    ? 33
    : Math.max(0, (opportunityCount / maxCount) * 100);
  const fillClass = isPlaceholder
    ? `${styles.stageRow__fill} ${styles["stageRow__fill--placeholder"]}`
    : styles.stageRow__fill;
  const showCountLabel = isPlaceholder || opportunityCount > 0;

  const bar = (
    <div className={styles.stageRow__track}>
      <div
        className={fillClass}
        data-testid="stage-row-bar-fill"
        style={{ width: `${widthPct}%`, backgroundColor: color }}
      >
        {showCountLabel && opportunityCount}
      </div>
    </div>
  );

  const tooltipContent =
    !isPlaceholder && opportunityCount > 0 ? (
      <StageTooltipContent
        color={color}
        opportunityCount={opportunityCount}
        opportunityNames={opportunityNames}
        remainingCount={remainingCount}
        stageName={stageName}
      />
    ) : null;

  return (
    <div className={styles.stageRow}>
      <span className={styles.stageRow__name}>{stageName.toUpperCase()}</span>
      <div className={styles.stageRow__row}>
        <BarTrackWrapper tooltipContent={tooltipContent} tooltipDelay={1000} tooltipMaxWidth="320px">
          {bar}
        </BarTrackWrapper>
        <span className={styles.stageRow__value}>
          {formatCompactCurrency(value, currency)}
        </span>
      </div>
    </div>
  );
};

StageRow.propTypes = {
  stageName: string.isRequired,
  color: string.isRequired,
  opportunityCount: number.isRequired,
  value: number.isRequired,
  currency: string,
  opportunityNames: arrayOf(string),
  remainingCount: number,
  maxCount: number.isRequired,
  isPlaceholder: bool,
};

export default StageRow;
